import React from 'react';
import { Link } from 'react-router-dom';
import { Globe, Users, TrendingUp, Shield, ArrowRight } from 'lucide-react';

const About = () => {
  return (
    <div>
      {/* Hero */}
      <section className="py-24 md:py-32 bg-slate-50" data-testid="about-hero">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="max-w-4xl">
            <span className="text-xs font-mono tracking-widest uppercase text-orange-500">About Us</span>
            <h1 
              className="text-5xl md:text-7xl font-bold tracking-tight uppercase mt-4 mb-6"
              style={{fontFamily: 'Barlow Condensed, sans-serif'}}
            >
              Connecting South Africa with Global Markets
            </h1>
            <p className="text-xl leading-relaxed text-slate-600 mb-8">
              NETEXEC GLOBAL is a freight forwarding and customs clearance partner helping South African businesses move cargo efficiently across international borders.
            </p>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-24 md:py-32 bg-white">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-24">
            <div>
              <h2 
                className="text-3xl md:text-5xl font-bold tracking-tight uppercase mb-6"
                style={{fontFamily: 'Barlow Condensed, sans-serif'}}
              >
                Who We Are
              </h2>
              <div className="space-y-4 text-base leading-relaxed text-slate-600">
                <p>
                  NETEXEC GLOBAL specializes in freight forwarding, customs clearance, and end-to-end logistics coordination for South African importers and exporters.
                </p>
                <p>
                  We serve SMEs and mid-sized businesses that need reliable cargo movement between South Africa, Europe, and Africa, with particular expertise in the Europe–Africa trade corridor.
                </p>
                <p>
                  Our services include air freight, ocean freight, customs clearance support, and complete logistics coordination—helping businesses navigate the complexities of cross-border trade.
                </p>
              </div>
            </div>
            <div className="h-96 rounded-sm overflow-hidden">
              <img
                src="https://images.unsplash.com/photo-1768677859674-42c517273db8?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85"
                alt="Busy shipping port with cranes and containers"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Values */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="inline-flex items-center justify-center w-20 h-20 bg-orange-50 text-orange-500 rounded-sm mb-4">
                <Globe className="w-10 h-10" />
              </div>
              <h3 className="font-semibold text-slate-900 mb-2 text-lg">Global Reach</h3>
              <p className="text-sm text-slate-600">Established routes connecting South Africa with Europe and Africa</p>
            </div>
            <div className="text-center">
              <div className="inline-flex items-center justify-center w-20 h-20 bg-orange-50 text-orange-500 rounded-sm mb-4">
                <Users className="w-10 h-10" />
              </div>
              <h3 className="font-semibold text-slate-900 mb-2 text-lg">Business-Focused</h3>
              <p className="text-sm text-slate-600">Tailored solutions for commercial cargo and business needs</p>
            </div>
            <div className="text-center">
              <div className="inline-flex items-center justify-center w-20 h-20 bg-orange-50 text-orange-500 rounded-sm mb-4">
                <TrendingUp className="w-10 h-10" />
              </div>
              <h3 className="font-semibold text-slate-900 mb-2 text-lg">Operational Excellence</h3>
              <p className="text-sm text-slate-600">Precision coordination and clear communication throughout</p>
            </div>
            <div className="text-center">
              <div className="inline-flex items-center justify-center w-20 h-20 bg-orange-50 text-orange-500 rounded-sm mb-4">
                <Shield className="w-10 h-10" />
              </div>
              <h3 className="font-semibold text-slate-900 mb-2 text-lg">Compliance Expertise</h3>
              <p className="text-sm text-slate-600">Expert customs clearance and regulatory support</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 md:py-32 bg-slate-50">
        <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
          <h2 
            className="text-3xl md:text-5xl font-bold tracking-tight uppercase mb-6"
            style={{fontFamily: 'Barlow Condensed, sans-serif'}}
          >
            Work With Us
          </h2>
          <p className="text-lg leading-relaxed text-slate-600 mb-8">
            Ready to streamline your import and export operations? Get in touch for a customized freight solution.
          </p>
          <Link
            to="/contact"
            data-testid="about-cta-btn"
            className="bg-slate-900 text-white px-8 py-4 rounded-sm text-base font-medium hover:bg-orange-500 transition-colors duration-300 inline-flex items-center gap-2"
          >
            Request a Quote
            <ArrowRight className="w-5 h-5" />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default About;